<template lang="pug">
  v-card
    v-card-title.pa-1
      v-text-field(autofocus clearable solo v-model='search' :append-icon='searchIcon' @click:append='vibrate();toggleSpeech()' :background-color="speechOn ? 'red' : 'none'" prepend-inner-icon='mdi-dialpad' :label="speechOn? feedback: recognition ? 'Speak or Type' : 'Search'" single-line hide-details @click:prepend-inner='showVirtualKeys=!showVirtualKeys')
    v-card-text.pa-0
      v-sheet(v-show='showVirtualKeys')
        v-row.pl-1.pr-1(no-gutters)
          v-col(cols='1')
            v-btn(small icon color='grey' @click="vibrate();search='*'")
              v-icon(color='yellow') mdi-star
          v-col(cols='1' v-for='i of 10' :key='i' @click="vibrate();search=search||'';search+=(i-1).toString()")
            v-btn(outlined small icon color='grey') {{i-1}}
          v-col(cols='1')
            v-btn(small icon @click='vibrate();search=search.slice(0,-1)')
              v-icon(color='grey') mdi-backspace
      v-divider
      small.pl-1(v-if='!feedback')
        | {{(search===&apos;*&apos;)?&grave;Favorites(${filteredProducts.length})&grave;:filteredProducts.length + &apos; &apos; + &apos;Products found&apos;}}
      small.pl-1(small v-if='feedback' color='red') {{feedback}}
      v-divider
      v-list.overflow-y-auto(style='max-height: 205px')
        div(v-for='(product,index) in filteredProducts' :key='index')
          v-list-item
            v-dialog(offset-x)
              template(v-slot:activator='{ on }')
                v-list-item-avatar(v-on='on' :tile='true')
                  img(:src="product.imageUrl || '/images/product.png'")
              v-sheet.mx-auto(elevation='18' height='100%' width='100%')
                flip-card
                  template(slot='front')
                    v-img.white--text(:src="product.pic || '/images/1.jpg'")
                    span.grey--text ({{product.code}}) {{ product.name }} [&#x20B9;{{product.rate}}]
                  template(slot='back')
                    v-label {{ product.desc }}
                    v-label {{ product.tags }}
            v-list-item-content
              v-list-item-title
                strong {{product.name}}
                | ({{product.code}})
              v-list-item-subtitle
                | Tags: {{(product.tags &amp;&amp; product.tags.length &amp;&amp; product.tags.join(&apos;,&apos;)) || &apos;no tags&apos;}}
            v-list-item-action
              v-list-item-action-text {{product.count}}(@{{product.rate}})
              v-list-item-action-text
                v-icon(v-if='product.isFav' color='yellow') mdi-star
                v-icon(medium @click='vibrate();selectProduct(product)') mdi-plus
                v-menu
                  template(v-slot:activator='{ on }')
                    v-icon(v-on.stop='on' color='grey lighten-1') mdi-dots-vertical
                  v-list
                    v-list-item(@click='vibrate();toggleFav(product)')
                      v-icon(v-if='!product.isFav' color='yellow') mdi-star-outline
                      v-icon(v-else color='yellow') mdi-star
                      v-list-item-title.pl-2(v-if='!product.isFav') Add to Favorites
                      v-list-item-title.pl-2(v-else) Remove from Favorites
          v-divider
</template>
<script>
import FlipCard from "./FlipCard.vue";
import { storeMixin } from "../../mixins/storeMixin.js";

export default {
  name: "product-selector",
  mixins: [storeMixin],
  components: { FlipCard },
  props: { products: Array },
  beforeMount() {
    if (this.myFeatures.eligibleFeatures.includes("VOICE")) {
      this.recognition = this.createSpeechRecognition();
    }
  },
  data: () => ({
    showVirtualKeys: true,
    rowsPerPageItems: [4, 8, 12],
    pagination: {
      rowsPerPage: 8
    },
    searchTerm: "",
    speechOn: false,
    recognition: null,
    feedback: ""
  }),
  computed: {
    filteredProducts() {
      if (!this.search) {
        return []; //this.products;
      } else {
        let results = [];
        if (this.search === "*") {
          results = this.products.filter(p => p.isFav);
        } else {
          results = this.products
            .filter(p => {
              const text =
                p.name.toLowerCase() +
                p.code.toLowerCase() +
                (p.tags ? p.tags.join(",").toLowerCase() : "") +
                (p.desc ? p.desc.toLowerCase() : "");
              const searchText =
                this.search !== 0 ? this.search.toLowerCase() : this.search;
              const inventoryExists = this.myFeatures.eligibleFeatures.includes(
                "INVENTORY"
              )
                ? Number(p.count) > 0
                : true;
              let found = true;
              const searchTerms = searchText.split(",");
              searchTerms.forEach(term => {
                term = term ? term.trim() : false;
                found = term ? found && text.indexOf(term) > -1 : found;
              });
              return inventoryExists && found;
            })
            .sort((p1, p2) => !!p2.isFav - !!p1.isFav);
        }
        return results;
      }
    },
    search: {
      get: function() {
        return this.searchTerm;
      },
      set: function(nVal) {
        this.searchTerm =
          this.searchTerm === "*" && nVal ? nVal.substring(1) : nVal;
        this.$forceUpdate();
      }
    },
    searchIcon() {
      let icon = "mdi-magnify";
      if (
        this.myFeatures.eligibleFeatures.includes("VOICE") &&
        this.recognition
      ) {
        icon = this.speechOn ? "mdi-stop" : "mdi-microphone";
      }
      return icon;
    }
  },
  methods: {
    createSpeechRecognition() {
      let recognition = null;
      if (!("webkitSpeechRecognition" in window)) {
        alert("Doesnt support speech recognition");
      } else {
        recognition = new window.webkitSpeechRecognition();
        recognition.continuous = false;
        recognition.interimResults = false;
        recognition.lang = "en-IN";
        recognition.onstart = () => {
          this.feedback = "Speak now";
          this.speechOn = true;
        };
        recognition.onerror = event => {
          this.feedback = event.error;
          this.speechOn = false;
        };
        recognition.onend = () => {
          this.feedback = "";
          this.speechOn = false;
        };
        recognition.onresult = event => {
          let transcript = "";
          for (let i = event.resultIndex; i < event.results.length; ++i) {
            if (event.results[i].isFinal) {
              transcript += event.results[i][0].transcript;
            }
          }
          transcript ? (this.search = transcript) : "";
          this.feedback = "";
          this.speechOn = false;
        };
      }
      return recognition;
    },
    toggleSpeech() {
      if (this.myFeatures.eligibleFeatures.includes("VOICE")) {
        this.speechOn = !this.speechOn;
      }
    },
    selectProduct(product) {
      this.$emit("selected", product);
    },
    toggleFav(product) {
      product.isFav = !product.isFav;
      this.updateFields({
        collectionName: "products",
        docId: product.id,
        subDoc: { isFav: product.isFav }
      });
      this.$forceUpdate();
    }
  },
  watch: {
    search() {
      let show = this.search ? false : true;
      this.$emit("showCart", show);
    },
    speechOn(nVal) {
      if (nVal) {
        this.search = "";
        this.recognition.start();
      } else {
        this.recognition.stop();
      }
    }
    // filteredProducts(nVal) {
    //   if (nVal.length === 1) {
    //     this.selectProduct(nVal[0]);
    //     this.search = "";
    //   }
    // }
  }
};
</script>